/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {
    bool, string, func, object,
} from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import ReactHtmlParser from 'react-html-parser';

const styles = {
    closeBtn: {
        position: 'absolute',
        right: '10px',
        top: '5px',
    },
    paperStyle: {
        margin: '14px',
    },
};

const PassportTncModal = ({
    dialogOpen,
    closeModal,
    tncContent,
    classes,
}) => (
    <Dialog
        open={dialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={closeModal}
        classes={{
            paper: classes.paperStyle,
        }}
    >
        <DialogContent>
            <IconButton
                data-testid="closeButton" // unit test
                className={classes.closeBtn}
                aria-label="Close"
                onClick={closeModal}
            >
                <CloseIcon />
            </IconButton>
            <DialogContentText id="alert-dialog-description">
                { ReactHtmlParser(tncContent) }
            </DialogContentText>
        </DialogContent>
    </Dialog>
);

PassportTncModal.propTypes = {
    dialogOpen: bool.isRequired,
    closeModal: func.isRequired,
    tncContent: string,
    classes: object.isRequired,
};

PassportTncModal.defaultProps = {
    tncContent: '',
};

export default withStyles(styles)(PassportTncModal);
